import { render, staticRenderFns } from "./AutoawardForm.vue?vue&type=template&id=0d4789e0&scoped=true&"
import script from "./AutoawardForm.vue?vue&type=script&lang=js&"
export * from "./AutoawardForm.vue?vue&type=script&lang=js&"
import style0 from "./AutoawardForm.vue?vue&type=style&index=0&id=0d4789e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4789e0",
  null
  
)

export default component.exports